import { ReactElement } from "react";
import Head from "next/head";
import { MainLayout } from "@/containers/layout/LandingLayout";

import Hero from "@/components/key-workers/Hero";
import Faq from "@/components/key-workers/Faq";

import ContactBanner from "@/components/key-workers/ContactBanner";

import { Props } from "@/components/howitworks/components/types";
import KeyWorkers from "@/components/key-workers/KeyWorkers";
import BetterPath from "@/components/key-workers/BetterPath";
import LatestArticles from "@/components/blog/latestArticles/LatestArticles";
import getConfig from "next/config";

const KeyWorkersPage = ({ theme = "dark" }: Props): JSX.Element => {
  const { publicRuntimeConfig } = getConfig();
  return (
    <>
      <Head>
        <title>Keyzy Helps Key Workers To Buy Their Homes with Rent To Buy</title>
        <link rel="canonical" href="https://www.keyzy.com/key-workers" />
        <meta
          name="description" key="description"
          content="Keyzy's rent to buy homeownership solution for key workers helps doctors, teachers, nurses, police and fire brigade to stop renting and start owning their home."
        />
        <meta
          name="twitter:card"
          content="Keyzy's rent-to-buy homeownership solution for key workers helps doctors, teachers, nurses, police and fire brigade to stop renting and start owning their home."
          key="twcard"
        />
        <meta name="twitter:creator" content="keyzyhomes" key="twhandle" />
        <meta property="og:url" content="/" key="ogurl" />
        <meta property="og:image" content="/key-workers/keyzy-meta-key-workers.png" key="ogimage" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Keyzy" key="ogsitename" />
        <meta
          property="og:title"
          content="Keyzy Helps Key Workers To Buy Their Homes with Rent To Buy"
          key="ogtitle"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_GB" />
        <meta
          property="og:description"
          content="Keyzy's rent-to-buy homeownership solution for key workers helps doctors, teachers, nurses, police and fire brigade to stop renting and start owning their home."
          key="ogdesc"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://keyzy.com/" },
                { "@type": "ListItem", "position": 2, "name": "Key Workers", "item": "https://keyzy.com/key-workers" },
              ],
            }),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Service",
              "name": "Keyzy Rent-to-Buy for Key Workers",
              "description": "Keyzy's rent-to-buy homeownership solution for key workers helps doctors, teachers, nurses, police and fire brigade to stop renting and start owning their home.",
              "url": "https://www.keyzy.com/key-workers",
              "provider": {
                "@type": "Organization",
                "name": "Keyzy",
                "url": "https://www.keyzy.com",
              },
              "areaServed": {
                "@type": "City",
                "name": "London",
              },
              "audience": {
                "@type": "Audience",
                "audienceType": "Key Workers",
              },
            }),
          }}
        />
      </Head>

      <div className="bg-white">
        <Hero />
        <KeyWorkers />
      </div>
      <div className="bg-landing-denim">
        <BetterPath />
      </div>
      <div className="bg-white">
        <LatestArticles
          selectedCategory={3 as number}
          excludeCategories={publicRuntimeConfig.NEXT_BLOG_LANDLORD_CATEGORY_ID}
        />
        <Faq />
        <ContactBanner />
      </div>
    </>
  );
};

KeyWorkersPage.getLayout = function getLayout(page: ReactElement) {
  return <MainLayout>{page}</MainLayout>;
};

export default KeyWorkersPage;
